import { gql, useMutation } from '@apollo/client';
import { useState } from 'react';
import { Button, Form, Modal } from '@atrocit/scl';
import ButtonArea from '../lib/forms/ButtonArea';
import ValidatedButton from '../lib/forms/ValidatedButton';

export default function DeleteCallModal({ isOpen, onClose, callId, refetch }) {
	const [ loading, setLoading ] = useState(false);

	const [ deleteCall ] = useMutation(gql`mutation Mutation($callId: Int!) {
        deleteCall(callId: $callId)
    }`);

	function process() {
		setLoading(true);
		deleteCall({ variables: { callId: callId } }).finally(() => { refetch(); onClose(); });
	}

	return <Modal isOpen={isOpen} onClose={onClose} title="Termijn verwijderen">
		{!loading && <Form style={{ maxWidth: "var(--u-384)" }} onSubmit={process}>
			<p style={{ marginTop: 0 }}>Wilt u deze termijn verwijderen? Deze actie kan niet ongedaan gemaakt worden.</p>
			<ButtonArea>
				<ValidatedButton type="submit" style={{ background: "var(--col-red)", color: "var(--col-white)", borderColor: 'var(--col-red-600)' }}>
					<span className="fa fa-trash" />&nbsp;Verwijderen
				</ValidatedButton>
				<Button onClick={onClose}>Annuleren</Button>
			</ButtonArea>
		</Form>}
		{loading && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
			<span className="fa fa-spinner fa-pulse" style={{ fontSize: 'var(--fs-18)' }} />
		</div>}
	</Modal>;
}